import { SearchIcon } from '@heroicons/react/outline';
import { Send, Refresh } from '@mui/icons-material';

import {
  TextField,
  TableCell,
  TableContainer,
  TableRow,
  TableHead as MuiTableHead,
  TableBody,
  Card,
  CardContent,
  Typography,
  Box,
  InputAdornment,
  Modal,
  CircularProgress,
  Button,
  Tooltip,
  Snackbar,
  Alert,
  IconButton,
  Table,
  Backdrop,
} from '@mui/material';
import {
  SubmitAttendance,
  UpdateSubmit,
} from '../../features/attendance/AttendanceSlice';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { SendMessages } from '../../features/attendance/AttendanceSlice';
import SendToMobileIcon from '@mui/icons-material/SendToMobile';
import { useDispatch, useSelector } from 'react-redux';
import { getLabelsByInstituteType } from '../../utils/constants';
import PeopleIcon from '@mui/icons-material/People';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import CloseIcon from '@mui/icons-material/Close';
import dayjs from 'dayjs';
import DownloadIcon from '@mui/icons-material/Download';
import api from '../../services/api';
import { debounce } from 'lodash-es';
export function AttendanceTable({
  Students,
  setStudents,
  loading,
  initialData,
  setInitialData,
  searchValues,
  absentCount,
  setAbsentCount,
  submitted,
  setSubmitted,
  hasChanges,
  setHasChanges,
}) {
  const smsService = useSelector(
    (state) => state?.auth?.successData?.userDetails?.smsService,
  );
  const dispatch = useDispatch();
  const [studentsList, setStudentsList] = useState();
  const [filteredData, setFilteredData] = useState([]);
  const [isSending, setIsSending] = useState(0);
  const [absent, setAbsent] = useState('');
  const [searchStudent, setSearchStudent] = useState(''); //Search value for the searvBar
  const [preview, setPreview] = useState(false); // to show the preview of the students
  const [isMarked, setIsMarked] = useState(false); //varibal to indicate the alll students are marked or not
  const [finalProcessing, setFinalProcessing] = useState(false); //variable to open  the Students List submission modals saying error or success
  const [finalResult, setFinalResult] = useState(1); //variable to show the submission status like success and error
  const [isDownloading, setIsDownloading] = useState(false);
  const [downloadError, setDownloadError] = useState(false);
  let { instituteType } = useSelector((state) => {
    return state.auth?.successData?.userDetails ?? {};
  });
  const filterStudents = useMemo(
    () =>
      debounce((text) => {
        if (text) {
          const data = studentsList?.filter(
            (student) =>
              student?.studentId?.toLowerCase().includes(text.toLowerCase()) ||
              (student?.rollNumber + '')
                ?.toLowerCase()
                .includes(text.toLowerCase()) ||
              student?.name
                .toLowerCase()
                .toString()
                .includes(text.toLowerCase()),
          );
          setFilteredData(data);
        } else {
          setFilteredData(studentsList);
        }
      }, 300),
    [studentsList],
  );
  function onRemarksChange(id, currentRemarks) {
    const changedList = studentsList?.map((obj) => {
      if (obj.studentId == id) {
        return { ...obj, remarks: currentRemarks };
      } else {
        return obj;
      }
    });
    setStudentsList(changedList);
    const data = changedList?.filter(
      (student) =>
        student?.studentId
          ?.toLowerCase()
          .includes(searchStudent.toLowerCase()) ||
        (student?.rollNumber + '')
          ?.toLowerCase()
          .includes(searchStudent.toLowerCase()) ||
        student?.name
          .toLowerCase()
          .toString()
          .includes(searchStudent.toLowerCase()),
    );

    setFilteredData(data);
    setHasChanges(true);
  }

  function onStatusChange(id, currentStatus) {
    let count = 0;
    const changedList = studentsList?.map((obj) => {
      if (obj.studentId == id) {
        //if id present
        if (currentStatus == 'absent') {
          //check absent or present
          count += 1;
          return { ...obj, status: currentStatus }; //if absent return absent
        } else {
          return { ...obj, status: currentStatus, remarks: '' }; //if present return present with remarks NOTHING
        }
      } //If id not present return as it is Brother
      else {
        if (obj.status == 'absent') {
          count += 1;
        }
        return obj;
      }
    });
    setStudentsList(changedList);
    const data = changedList?.filter(
      (student) =>
        student?.studentId
          ?.toLowerCase()
          .includes(searchStudent.toLowerCase()) ||
        (student?.rollNumber + '')
          ?.toLowerCase()
          .includes(searchStudent.toLowerCase()) ||
        student?.name
          .toLowerCase()
          .toString()
          .includes(searchStudent.toLowerCase()),
    );
    setFilteredData(data);
    setAbsentCount(count);
    setHasChanges(true);
  }
  function onReset() {
    let count = 0;
    initialData?.map((obj) => {
      if (obj.status == 'absent') {
        count = count + 1;
      }
    });
    setFilteredData([...initialData]);
    setStudentsList(initialData);
    setAbsentCount(count);
    setStudents(initialData);
    setHasChanges(false);
    setSearchStudent('');
    searchRef.current = '';
  }
  function onSubmit() {
    let val = studentsList?.find((obj) => obj.status == '');
    if (val) {
      setIsMarked(true);
    } else {
      setPreview(true);
    }
  }
  async function finalSubmit() {
    setPreview(false);
    setFinalProcessing(true);
    const finalData = [];
    studentsList?.map((obj) => {
      if (obj.status == 'absent') {
        finalData.push({ studentId: obj.studentId, remarks: obj.remarks });
      }
    });
    const response = await dispatch(
      SubmitAttendance({
        ...searchValues,
        absenties: finalData,
        instituteType: instituteType,
      }),
    ).unwrap();
    if (response.status == 200) {
      setInitialData(filteredData);
      setFinalResult(2);
      setSubmitted(true);
      setSearchStudent('');
      setFilteredData(studentsList);
      searchRef.current = '';
      setHasChanges(false);
      await dispatch(UpdateSubmit(finalData));
    } else {
      setFinalResult(3);
    }
    setHasChanges(false);
    setTimeout(() => {
      setFinalProcessing(false);
    }, 2000);
  }
  async function sendMessages() {
    setIsSending(1);
    const finalData = [];
    filteredData?.map((obj) => {
      if (obj.status == 'absent') {
        finalData.push({ studentId: obj.studentId, remarks: obj.remarks });
      }
    });
    setAbsent(finalData.length);

    setTimeout(async () => {
      try {
        const response = await dispatch(
          SendMessages([finalData, searchValues?.attendanceDate]),
        ).unwrap();
        response ? setIsSending(2) : setIsSending(3);
      } catch (error) {
        if (error === 'SMSError') {
          setIsSending(4);
        }
        console.log(error);
      }
    }, 1500);

    setTimeout(() => {
      setIsSending(0);
    }, 6000);
  }
  //const remarksRef = useRef([]);
  const generateTableBody = useMemo(() => {
    return filteredData?.map((student) => (
      <TableRow
        key={student.studentId}
        hover
        className={`h-3 p-0 m-0 ${student?.status == 'absent' ? 'bg-red-50' : ''}`}
      >
        <TableCell>
          <Typography variant='body2'>{student?.studentId}</Typography>
        </TableCell>

        <TableCell>
          <Typography variant='body2'>{student?.rollNumber}</Typography>
        </TableCell>

        <TableCell>
          <Typography variant='body2'>{student?.name}</Typography>
        </TableCell>

        <TableCell>
          <select
            className={`h-8 px-3 border rounded-md text-sm
                          ${student.status === 'present' ? 'text-green-600 font-bold' : ''}
                          ${student.status === 'absent' ? 'text-red-600 font-bold' : ''}`}
            value={student.status}
            onChange={(e) => onStatusChange(student?.studentId, e.target.value)}
          >
            <option value='' disabled>
              Select
            </option>
            <option className='text-green-400 font-bold' value='present'>
              Present
            </option>
            <option className='text-red-400 font-bold' value='absent'>
              Absent
            </option>
          </select>
        </TableCell>

        <TableCell>
          <TextField
            key={`${student.studentId}-${student.remarks}`}
            size='small'
            disabled={!(student.status == 'absent')}
            defaultValue={student.remarks}
            onBlur={(e) => {
              onRemarksChange(student.studentId, e.target.value);
            }}
            onChange={() => setHasChanges(true)}
            placeholder='Add remarks (optional)'
            className='max-w-96 '
            variant='standard'
          />
        </TableCell>
      </TableRow>
    ));
  }, [filteredData]);
  async function downloadStudents(classDetails) {
    try {
      if (!(classDetails.departmentName && classDetails.className)) {
        throw new Error();
      }
      const fileResponse = await api({
        baseURL: process.env.REACT_APP_API_BASE_URL,
        url: '/attendance/downloadOneDayReport',
        method: 'POST',
        responseType: 'blob',
        data: { ...classDetails, instituteType: instituteType },
      });
      const blob = new Blob([fileResponse?.data], {
        type: fileResponse.headers['content-type'],
      });

      let filename = 'Attendance.xlsx';
      const contentDisposition = fileResponse?.headers?.filename;
      filename = contentDisposition;

      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = filename;
      link.click();
      URL.revokeObjectURL(url);
      setIsDownloading(false);
    } catch (err) {
      setDownloadError(true);
      setIsDownloading(false);
      console.error('Download failed', err);
    }
  }
  const searchRef = useRef('');
  useEffect(() => {
    setFilteredData(Students);
    setSearchStudent('');
    searchRef.current = '';
    setStudentsList(Students);
  }, [Students]);
  return (
    <>
      {/*                                                     Table Data */}
      <div className='w-full overflow-auto mt-4'>
        <Card className='  rounded-lg border shadow-none min-w-[700px] p-0 '>
          <CardContent className='p-0 '>
            <Box className='p-6 border-b flex gap-4 md:justify-between items-center max-[700px]:flex-col max-[700px]:items-start'>
              <Box>
                <Typography
                  variant='h6'
                  className='font-medium'
                  color='primary'
                >
                  Student Attendance
                </Typography>
                <Typography variant='body1' className=' mt-1'>
                  Mark attendance for each student
                </Typography>
              </Box>
              <div className='w-64 hover:w-80  transition-all duration-300 ease-in-out'>
                <TextField
                  size='small'
                  fullWidth
                  placeholder='Search by Id, Name ....'
                  inputRef={searchRef}
                  value={searchStudent}
                  autoComplete='off'
                  variant='outlined'
                  onChange={(e) => {
                    const value = e.target.value;
                    if (value !== ' ') {
                      setSearchStudent(value);
                      filterStudents(value);
                    }
                  }}
                  slotProps={{
                    input: {
                      endAdornment: (
                        <InputAdornment position='end'>
                          <SearchIcon className='size-5 text-gray-600' />
                        </InputAdornment>
                      ),
                    },
                  }}
                />
              </div>
            </Box>

            <TableContainer
              className={`overflow-auto ${Students.length > 0 ? 'h-auto max-h-[60vh]' : ''} `}
            >
              {loading && (
                <div className=' flex flex-col justify-center items-center min-h-full my-8'>
                  <CircularProgress className='mt-8'></CircularProgress>
                  <br />
                  Fetching Data
                </div>
              )}
              {!loading && (
                <Table size='small' stickyHeader>
                  <MuiTableHead>
                    <TableRow className='border ' hover>
                      <TableCell
                        className='  pl-2   font-bold  text-blue-500'
                        sx={{ typography: 'body1' }}
                      >
                        Student Id
                      </TableCell>

                      <TableCell
                        className=' pl-2   font-bold text-blue-500'
                        sx={{ typography: 'body1' }}
                      >
                        Roll Number
                      </TableCell>

                      <TableCell
                        className=' font-bold  text-blue-500'
                        sx={{ typography: 'body1' }}
                      >
                        Student Name
                      </TableCell>
                      <TableCell
                        className=' font-bold text-blue-500 '
                        sx={{ typography: 'body1' }}
                      >
                        Status
                      </TableCell>
                      <TableCell
                        className=' font-bold  text-blue-500'
                        sx={{ typography: 'body1' }}
                      >
                        Remarks
                      </TableCell>
                    </TableRow>
                  </MuiTableHead>
                  <TableBody>
                    {Students?.length == 0 && (
                      <TableRow hover>
                        <TableCell
                          className='text-center text-red-500 m-2'
                          colSpan={5}
                        >
                          No Rows
                        </TableCell>
                        <TableCell colSpan={20}></TableCell>
                      </TableRow>
                    )}
                    {generateTableBody}
                    {/* {table_body} */}
                  </TableBody>
                </Table>
              )}
            </TableContainer>
          </CardContent>
        </Card>
      </div>
      <>
        <Card className=' rounded-lg  shadow-none border mt-6'>
          <CardContent className='md:p-6 m-0 pl-2'>
            <Box className='flex flex-col  sm:flex-row justify-between items-start sm:items-center gap-4 '>
              <Box className=' min-w-fit'>
                <Typography variant='h6' className='font-medium'>
                  Actions
                </Typography>
                {hasChanges ? (
                  <Typography variant='h6' className=' mt-1 text-red-500'>
                    You have unsaved changes
                  </Typography>
                ) : (
                  <Typography variant='h6' className=' mt-1 text-green-600 '>
                    No changes to save
                  </Typography>
                )}
              </Box>

              <Box className='flex gap-2 lg:gap-3 flex-wrap  min-w-60'>
                <Button
                  variant='outlined'
                  color='primary'
                  sx={{ borderRadius: '50px' }}
                  onClick={onReset}
                  disabled={!hasChanges}
                  startIcon={<Refresh sx={{ strokeWidth: 2 }} />}
                  className='w-full md:w-fit font-medium border  normal-case '
                >
                  Reset
                </Button>

                <Tooltip
                  placement='top'
                  title={
                    submitted ? (
                      hasChanges ? (
                        <div className='text-[14px]'>
                          Please Submit the Changes First.
                        </div>
                      ) : (
                        <div className='text-[14px]'> Download the Reports</div>
                      )
                    ) : (
                      <div className='text-[14px]'>
                        Submit the Attendance first
                      </div>
                    )
                  }
                >
                  <div className='inline-block  w-full md:w-fit'>
                    <Button
                      color='primary'
                      sx={{ borderRadius: '50px' }}
                      startIcon={<DownloadIcon sx={{ strokeWidth: 1 }} />}
                      disabled={!submitted || hasChanges}
                      onClick={() => {
                        if (!hasChanges) {
                          setIsDownloading(true);
                          downloadStudents({ ...searchValues });
                        } else {
                          return undefined;
                        }
                      }}
                      variant='outlined'
                      className='w-full  font-medium border  normal-case'
                    >
                      Reports
                    </Button>
                  </div>
                </Tooltip>

                <Tooltip
                  placement='top'
                  title={
                    smsService ? (
                      submitted ? (
                        hasChanges ? (
                          <div className='text-[14px]'>
                            Please Submit the Changes First.
                          </div>
                        ) : (
                          <div className='text-[14px]'>
                            {' '}
                            Click to send Messages
                          </div>
                        )
                      ) : (
                        <div className='text-[14px]'>
                          Submit the Attendance first
                        </div>
                      )
                    ) : (
                      <div>
                        SMS Service not Enabled
                        <div className='text-center'>contact @Support Team</div>
                      </div>
                    )
                  }
                >
                  <div className='inline-block  w-full md:w-fit'>
                    <Button
                      color='primary'
                      sx={{ borderRadius: '50px' }}
                      startIcon={<SendToMobileIcon sx={{ strokeWidth: 1 }} />}
                      disabled={!smsService || !submitted || hasChanges}
                      onClick={!hasChanges ? sendMessages : undefined}
                      variant='outlined'
                      className='w-full  font-medium border  normal-case'
                    >
                      Send Absent Messages
                    </Button>
                  </div>
                </Tooltip>

                {!submitted ? (
                  <Button
                    color='success'
                    sx={{ borderRadius: '50px' }}
                    variant='contained'
                    onClick={onSubmit}
                    disabled={!filteredData?.length}
                    startIcon={<Send />}
                    className={`gap-2  w-full md:w-fit font-medium border shadow-none normal-case  ${filteredData?.length > 0 ? ' text-white' : ''} `}
                  >
                    Submit Attendance
                  </Button>
                ) : (
                  <Button
                    color='primary'
                    variant='contained'
                    sx={{ borderRadius: '50px' }}
                    onClick={onSubmit}
                    disabled={!filteredData?.length > 0}
                    startIcon={<Send className='text-white' />}
                    className=' font-medium max-sm:w-full text-white  normal-case shadow-none '
                  >
                    ReSubmit Attendance
                  </Button>
                )}
              </Box>
            </Box>
          </CardContent>
        </Card>
        <Snackbar
          open={isSending == 2}
          autoHideDuration={6000}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        >
          <Alert
            severity='success'
            variant='filled'
            onClose={() => setIsSending(0)}
            sx={{ width: '100%' }}
          >
            <pre className='hidden md:inline'> </pre>
            {absent} Messages Sent Successfully.
            <pre className='hidden md:inline'></pre>
          </Alert>
        </Snackbar>

        <Snackbar
          open={isSending == 3}
          autoHideDuration={6000}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        >
          <Alert
            severity='error'
            variant='filled'
            onClose={() => setIsSending(0)}
            sx={{ width: '100%' }}
          >
            <pre className='hidden md:inline'> </pre>Error in Sending the{' '}
            {absent} Messages.
          </Alert>
        </Snackbar>

        <Snackbar
          open={isSending == 4}
          autoHideDuration={6000}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        >
          <Alert
            severity='error'
            variant='filled'
            onClose={() => setIsSending(0)}
            sx={{ width: '100%' }}
          >
            <pre className='hidden md:inline'> </pre>Can't send
            Messages,Absentie's count {absent} is more than Pending SMS's count.
          </Alert>
        </Snackbar>
      </>
      <Snackbar
        open={downloadError}
        autoHideDuration={3000}
        onClose={() => {
          setDownloadError(false);
        }}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <Alert
          onClose={() => {
            setDownloadError(false);
          }}
          severity='error'
          variant='filled'
          sx={{ width: '100%' }}
        >
          There is an Error in Downloading the Reports !
        </Alert>
      </Snackbar>

      <Backdrop
        sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
        open={isDownloading}
      >
        <div>
          <div className='text-center'>
            <CircularProgress color='inherit' />
          </div>
          <div className='text-center'>Downloading ..</div>
          <div className='text-center'>{downloadError}</div>
        </div>
      </Backdrop>
      <Modal //Modal  to Preview of the Attendance List
        open={preview}
        aria-labelledby='modal-modal-title'
        aria-describedby='modal-modal-description'
      >
        <Box className='flex flex-col max-h-[97%] w-5/6 md:w-1/2 xl:w-1/3  absolute top-1/2 left-1/2  -translate-x-1/2 -translate-y-1/2 bg-white  rounded-lg shadow-lg '>
          <div className='text-right border-b p-0'>
            <IconButton
              className='p-1 mt-1 mr-1'
              onClick={() => setPreview(false)}
            >
              <CloseIcon className='size-8  mt-1' />
            </IconButton>
          </div>
          <div className='  overflow-y-auto  flex-1 p-4 relative'>
            <PreviewContent
              students={studentsList}
              searchValues={searchValues}
              absent={absentCount}
            />
          </div>
          <div className='border-t p-1 flex justify-end gap-4'>
            <Button
              variant='outlined'
              color='error'
              onClick={() => setPreview(false)}
            >
              Cancel
            </Button>
            <Button variant='contained' color='success' onClick={finalSubmit}>
              {''} OK {''}
            </Button>
          </div>
        </Box>
      </Modal>
      <Modal //Modal  to show status of Sending the Absent Messages List to the  Parent Mobile
        open={isSending == 1}
        onClose={() => {
          setIsSending(0);
        }}
      >
        <div className='absolute top-1/2 left-1/2  -translate-x-1/2 -translate-y-1/2 bg-white  min-w-72 p-6 rounded-lg shadow-xl'>
          <div className='text-center m-4'>
            <CircularProgress color='inherit' />
            <p className='text-gray-600 text-xl mt-4'>
              Sending the absent messages to parents
            </p>
          </div>
        </div>
      </Modal>

      <Modal // Modal to show weather all the studnets are marked or not
        open={isMarked}
        onClose={() => setIsMarked(false)}
        aria-labelledby='modal-modal-title'
        aria-describedby='modal-modal-description'
      >
        <Box className='flex flex-col max-h-[97%] absolute top-1/2 left-1/2  -translate-x-1/2 -translate-y-1/2 bg-white  rounded-lg shadow-lg p-4 text-center'>
          <div className='text-center'>
            <PeopleIcon className='size-20 text-blue-400 ' />
          </div>
          <p className='text-base md:text-xl lg:text-2xl text-orange-400'>
            <ErrorOutlineIcon className='size-8' /> Some students are not
            Marked{' '}
          </p>
          <div className='text-center'>
            <button
              className='border px-3 py-1 rounded bg-orange-400 hover:shadow-slate-400 '
              onClick={() => setIsMarked(false)}
            >
              OK
            </button>
          </div>
        </Box>
      </Modal>

      <Modal //Modal  to show status of the submission of the Attendance List
        open={finalProcessing}
        onClose={() => {
          setFinalProcessing(false);
        }}
      >
        <div className='absolute top-1/2 left-1/2  -translate-x-1/2 -translate-y-1/2 bg-white p-6 rounded-lg shadow-xl'>
          {finalResult == 1 && (
            <div className='text-center m-4'>
              <CircularProgress />
              <p className='text-green-600 text-xl mt-4'>
                Submitting the Attendance
              </p>
            </div>
          )}
          {finalResult == 2 && (
            <div className='text-center   w-72'>
              <img
                src='/images/success.gif'
                alt='Success'
                className='mx-auto  size-40 rounded-full object-cover '
              />
              <p className='text-green-600 text-xl '>
                {' '}
                Attendance Submitted Successfully
              </p>
            </div>
          )}
          {finalResult == 3 && (
            <div className='text-center m-4'>
              <CircularProgress color='error' />
              <p className='text-red-600 text-xl mt-4'>
                Error in Submitting the Attendance
              </p>
            </div>
          )}
        </div>
      </Modal>
    </>
  );
}

const PreviewContent = React.memo(({ students, searchValues, absent }) => {
  let { instituteType } = useSelector((state) => {
    return state.auth?.successData?.userDetails ?? {};
  });
  let { Department, Class, Section } = getLabelsByInstituteType(instituteType);
  return (
    <>
      <div className='grid grid-cols-1 sm:grid-cols-2 bg-indigo-50 p-2 mb-2 rounded '>
        <div>
          <text className='text-lg  md:text-xl font-bold'>Class Info</text>
          <br />
          <text>{`Date  : ${dayjs(searchValues?.attendanceDate).format('DD-MM-YYYY')}`}</text>
          <br />
          <text>{`${Department} : ${searchValues?.departmentName}`}</text>
          <br />
          <text>{`${Class} : ${searchValues?.className}`}</text>
          <br />
          {searchValues?.sectionName && (
            <p>{`${Section} : ${searchValues?.sectionName} \n `}</p>
          )}
        </div>

        <div className='flex md:justify-center '>
          <div>
            <text className='text-lg  md:text-xl font-bold'>Summary</text>
            <br />
            <text>{`Present - ${students?.length - absent}`}</text>
            <br />
            <text>{`Absent - ${absent}`}</text>
            <br />
            <text>{`Total  - ${students?.length}`}</text>
            <br />
          </div>
        </div>
      </div>
      <TableContainer className='overflow-auto border h-fit max-h-[60vh] rounded-lg'>
        <Table size='small' stickyHeader>
          <MuiTableHead>
            <TableRow className='hover:bg-gray-200 text-lg '>
              <TableCell className='w-24  font-bold text-sm'>
                Student Id.
              </TableCell>
              <TableCell className='w-60 font-bold'>Student Name</TableCell>
              <TableCell className='w-28 font-bold'>Status</TableCell>
              <TableCell className='w-40 font-bold text-center'>
                Remarks
              </TableCell>
            </TableRow>
          </MuiTableHead>
          <TableBody>
            {students?.map((student) => (
              <TableRow
                key={student.studentId}
                hover
                className={`h-3  m-0 p-0 *:pl-2 *:p-0 *:m-0  ${student?.status == 'absent' ? 'bg-red-50' : ''}`}
              >
                <TableCell>{student?.studentId}</TableCell>

                <TableCell className='min-w-40 w-60'>{student?.name}</TableCell>

                <TableCell className='p-0'>
                  {student?.status == 'absent' ? (
                    <button className='border p-[2px] px-2 m-1 rounded bg-red-600 text-white'>
                      Absent
                    </button>
                  ) : (
                    <button className='border p-[2px] px-2 m-1 rounded'>
                      Present
                    </button>
                  )}
                </TableCell>
                <TableCell>
                  <div className='text-center min-w-40'>
                    {student?.remarks || '-'}
                  </div>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
});
PreviewContent.displayName = 'PreviewContent';
